import { useCallback, useEffect } from 'react';

var useNvModal = function (ref, _a) {
    var _b = _a === void 0 ? {} : _a, onClose = _b.onClose;
    var openModalDialog = function () {
        var _a, _b;
        (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.showModal) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    var closeModalDialog = function () {
        var _a, _b;
        (_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.close) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    var closeEvents = useCallback(function () {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    useEffect(function () {
        var reference = ref === null || ref === void 0 ? void 0 : ref.current;
        reference === null || reference === void 0 ? void 0 : reference.addEventListener('close', closeEvents);
        return function () {
            reference === null || reference === void 0 ? void 0 : reference.removeEventListener('close', closeEvents);
        };
    }, [closeEvents, ref]);
    return {
        closeModalDialog: closeModalDialog,
        openModalDialog: openModalDialog,
    };
};
var useBackdropEvent = function (ref, onBackdropClick) {
    var backdropModalClick = useCallback(function (event) {
        if (event.target.nodeName === 'DIALOG') {
            onBackdropClick === null || onBackdropClick === void 0 ? void 0 : onBackdropClick();
        }
    }, [onBackdropClick]);
    useEffect(function () {
        var modal = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!modal)
            return;
        modal.addEventListener('click', backdropModalClick);
        return function () {
            modal.removeEventListener('click', backdropModalClick);
        };
    }, [ref, backdropModalClick]);
};

export { useBackdropEvent, useNvModal };
//# sourceMappingURL=NvModal.hooks.esm.js.map
